import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { HisDateUtils } from '../utils';

/**
 * Validatoren für Date-Werte
 * Unterstützte Operatoren:
 * - minDate
 * - maxDate
 */
export class HisDateValidator {

    public static minDate( refDate: string | number | Date ): ValidatorFn {
        let localDate = HisDateUtils.convertToLocalDate( refDate );
        return ( control: AbstractControl<Date | string> ): ValidationErrors => {
            return this.doValidate( 'minDate', localDate, control );
        };
    }

    public static maxDate( refDate: string | number | Date ): ValidatorFn {
        let localDate = HisDateUtils.convertToLocalDate( refDate );
        return ( control: AbstractControl<Date | string> ): ValidationErrors => {
            return this.doValidate( 'maxDate', localDate, control );
        };
    }

    /**
     * Validiere den Input eines form controls c.
     * c.value kann ein string sein (aus Eingabefeldern) oder ein Date-Objekt (aus der p-calendar-Komponente).
     */
    private static doValidate( operator: string, refDate: Date, c: AbstractControl<Date | string> ): ValidationErrors {
        if (c.value === null || c.value === undefined || c.value === '') {
            // leeres Input-Feld -> keine Validierung
            return null;
        }

        let currentDate = HisDateUtils.convertToLocalDate( c.value );
        if (currentDate == null) {
            // Verhindere falsche minDate-Fehlermeldung bei nicht parsebarem Datumsstring
            return null;
        }

        let valid = true;
        if ( operator === 'minDate' ) {
            valid = currentDate.getTime() >= refDate.getTime();
        } else if ( operator === 'maxDate' ) {
            valid = currentDate.getTime() <= refDate.getTime();
        }

        if ( valid ) {
            return null;
        }

        let errorObject = {} as any;
        errorObject.valid = false;
        errorObject.actualValue = currentDate;
        errorObject.refValue = refDate;
        let errorState: Record<string, any> = {}; // können wir den Generic-Typ besser eingrenzen?
        errorState[operator] = errorObject;
        return errorState;
    }
}
